<script lang="ts">
	//Components
	import ActionsContext from '../WebHooksHelpers/ActionsContext.svelte';

	export let device;

	//Just a component to point that type is for adc actions
</script>

<ActionsContext {device} type={'adc'} />
